import { graphql } from '../generated';

export const GET_VIEWER = graphql(`
  query GetViewer {
    viewer {
      user {
        id
        email
        name
        initials
      }
      suggestedWorkspaceName
      workspace {
        ...WorkspaceFields
      }
    }
  }
`);
